import { FAIcon } from "@sgi/gravity/FAIcon";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import CSS from "csstype";

export default function VerifiedIcon() {
  const checkMark: CSS.Properties = {
    color: "darkseagreen",
    animationIterationCount: "1",
  };

  return (
    <div data-testid="checkMark-test">
      <FAIcon icon={faCircleCheck} style={checkMark} bounce></FAIcon>
    </div>
  );
}
